import { computed, reactive } from 'vue'
import { useStore } from 'vuex'

export default function (model) {
  const cols = reactive([
    {
      label: '单位名称',
      prop: 'deptName',
      align: 'center'
    },

    {
      label: '单位全称',
      prop: 'fullName',
      align: 'center'
    },
    {
      label: '单位类型',
      prop: 'deptCategoryName',
      align: 'center',
      width: 100
    },
    {
      label: '排序',
      prop: 'sort',
      align: 'center'
    },
    {
      type: 'buttons',
      label: '操作',
      buttons: ['view', 'edit', 'delete'],
      width: 260,
      align: 'center'
    }
  ])
  const vail = name => {
    return TdUI.getConfig('admin_org_edit_config') != null ? TdUI.getConfig('admin_org_edit_config').split(',').includes(name) : true
  }

  const formCols = reactive([
    {
      label: '基础信息',
      code: 'base',
      type: 'group',
      show: computed(() => vail('base')),
      icon: 'el-icon-info',
      children: [
        {
          label: '单位名称',
          prop: 'deptName',
          type: 'input',
          show: computed(() => vail('deptName')),
          rules: [
            {
              required: true,
              message: '请输入单位名称',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '单位全称',
          prop: 'fullName',
          type: 'input',
          show: computed(() => vail('fullName')),
          rules: [
            {
              required: true,
              message: '请输入单位全称',
              trigger: 'blur'
            }
          ]
        },
        {
          label: '联系人',
          prop: 'concact',

          attrs: {
            placeholder: '联系人'
          }
        },
        {
          label: '联系电话',
          prop: 'phone',
          show: computed(() => vail('phone')),
          type: 'input'
        },
        {
          label: '邮箱',
          prop: 'email',
          attrs: {
            placeholder: '邮箱'
          }
        }
        // {
        //   label: '行政区划',
        //   prop: 'areaCode',
        //   show: computed(() => vail('areaCode')),
        //   attrs: {
        //     mode: 'view',
        //     checkStrictly: true,
        //     type: TdUI.getConfig('admin_org_Area_Self') == null || TdUI.getConfig('admin_org_Area_Self') == false ? 'all' : 'self'
        //   },
        //   type: 'td-region-select'
        // }
      ]
    },
    {
      label: '附加信息',
      code: 'exta',
      show: computed(() => vail('exta')),
      type: 'group',
      icon: 'el-icon-s-cooperation',
      children: [
        {
          label: '单位电话',
          prop: 'deptTel',
          'suffix-icon': 'el-icon-phone-outlin',
          show: computed(() => vail('deptTel'))
        },
        {
          label: '单位地址',
          prop: 'deptAddress',

          'suffix-icon': 'el-icon-s-promotion',
          show: computed(() => vail('deptAddress'))
        },
        {
          label: '单位联系人',
          prop: 'deptContactMan',
          show: computed(() => vail('deptContactMan'))
        },
        {
          label: '单位邮政编码',
          prop: 'deptPostcode',
          show: computed(() => vail('deptPostcode'))
        },
        {
          label: '复议单位',
          prop: 'reconsiderDept',
          show: computed(() => vail('reconsiderDept'))
        },
        {
          label: '诉讼单位',
          prop: 'lawsuitDept',
          show: computed(() => vail('lawsuitDept'))
        },
        {
          label: '调查单位',
          prop: 'surveyDept',
          show: computed(() => vail('surveyDept'))
        }
      ]
    },
    {
      label: '行政缴费',
      code: 'other',
      type: 'group',
      icon: 'el-icon-s-finance',
      show: computed(() => vail('other')),
      children: [
        {
          label: '缴款账户',
          prop: 'payBankAccount',
          show: computed(() => vail('payBankAccount')),
          attrs: {
            placeholder: '缴款银行账户'
          }
        },
        {
          label: '开户银行',
          prop: 'payBankName',
          show: computed(() => vail('payBankName')),
          attrs: {
            placeholder: '缴款银行名称'
          }
        },
        {
          label: '缴款账号',
          prop: 'payBankNumber',
          attrs: {
            placeholder: '缴款银行账号'
          },
          show: computed(() => vail('payBankNumber'))
        },
        {
          label: '通知书领取',
          prop: 'payClaimAddress',
          attrs: {
            placeholder: '缴款通知书领取地址'
          },
          show: computed(() => vail('payClaimAddress'))
        }
      ]
    }
  ])

  return {
    cols,
    formCols
  }
}
